// Constant: Meta > Product name
const PRODUCT_NAME = 'aiXplain'

// Export
export {
	PRODUCT_NAME
}
